
export const passwordRegex =/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/i;


// WEBPACK FOOTER //
// /opt/build/repo/src/app/shared/utils/password-regex.ts